export default function isValid(value, isValid) {
  return isValid;
}
